import {
  CloudOutlined,
  CloudServerOutlined,
  CloudSyncOutlined,
  CloudUploadOutlined,
  ControlOutlined,
  FileDoneOutlined,
  MobileOutlined,
  RightSquareOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import React from "react";

export const PortalTitle = "HomeAssure™ Cloud Portal";
export const DefaultServiceProvider = "COMMSCOPE";
export const AppStorageKeys = {
  envVars: "ENV_VARS_FE",
  currentUser: "current_user",
  appEnv: "app_env",
};

export const DefaultTablePageSize = 20;
export const TablePageSizes = [10, 20, 30, 40, 50, 100];

export const AppEnvs = {
  HS: "HomeSight",
  HA: "HACloud",
  SA: "StandAlone",
};
export const DeviceManagePaths = {
  device: "device",
  group: "group",
  code: "asset",
  order: "order",
  purOrder: "purOrder",
};

export const NavMenuItems = {
  serviceProvider: {
    key: "service_provider",
    label: "Provider/Channel Management",
    icon: (props) => <CloudOutlined {...props} />,
  },
  help: { key: "help", label: "Help" },
  orderManagement: {
    key: "order_management",
    label: "Order Management",
    icon: (props) => <FileDoneOutlined {...props} />,
  },
  service: {
    key: "service",
    label: "Service Management",
    icon: (props) => <CloudSyncOutlined {...props} />,
  },
  serviceOffering: {
    key: "service_offering",
    label: "SAAS Offer Management",
    icon: (props) => <CloudUploadOutlined {...props} />,
  },
  serviceTier: {
    key: "service_tier",
    label: "SAAS Tier Management",
    icon: (props) => <CloudServerOutlined {...props} />,
  },
  deviceModel: {
    key: "device_model",
    label: "Device Model Management",
    icon: (props) => <ControlOutlined {...props} />,
  },
  codeManagement: {
    key: "code_management",
    label: "Code and App Management",
    icon: (props) => <RightSquareOutlined {...props} />,
  },
  deviceManagement: {
    key: "device_management",
    label: "Device SKU Management",
    icon: (props) => <MobileOutlined {...props} />,
  },
  configuration: {
    key: "configuration",
    label: "Configuration Management",
    icon: (props) => <SettingOutlined {...props} />,
    service: {
      key: "service_config",
      label: "Service",
    },
    deviceModel: {
      key: "device_model_config",
      label: "Device Model",
    },
    serviceProvider: {
      key: "provider_config",
      label: "Service Provider",
    },
    group: {
      key: "group_config",
      label: "Group",
    },
    device: {
      key: "device_config",
      label: "Device",
    },
  },
};
export const DefaultMenu = NavMenuItems.serviceProvider.key;

export const BasicActions = {
  add: "Add",
  edit: "Edit",
  view: "View",
};

export const APIResponseStatus = {
  success: "Success",
  fail: "Failure",
};

export const APIResponseErrorCodes = {
  sessionExpired: "Token-Verification-Failure",
  unauthorizedAccess: "UserAccess-to-Method-NotAllowed",
};

export const EntityStatus = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
  Enabled: "Enabled",
  Disabled: "Disabled",
};

export const StatusFilters = [
  { text: EntityStatus.ACTIVE, value: EntityStatus.ACTIVE },
  { text: EntityStatus.INACTIVE, value: EntityStatus.INACTIVE },
];

export const BasicMaturityStates = {
  stable: { value: "Stable", label: "Stable" },
  beta: { value: "Beta", label: "Beta" },
  experimental: { value: "Experimental", label: "Experimental" },
};

export const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
  },
};
export const tailItemLayout = {
  wrapperCol: {
    xs: { offset: 0 },
    sm: { offset: 8 },
  },
};

export const rowLayout = {
  gutter: 12,
};
export const colLayout = {
  xs: 24,
  md: 12,
};

/** Sample JSON Texts */
export const BulkDeviceJSON = `[
  {
    "deviceid": "<DEVICE-ID>",
    "modelnumber": "<MODEL-NUMBER>",
    "basemacaddress": "<00:00:00:00:00:00>",
    "devicename": "<device name> (optional)"
  },
  {
    "deviceid": "<DEVICE-ID>",
    "modelnumber": "<MODEL-NUMBER>",
    "basemacaddress": "<00:00:00:00:00:00>",
    "devicename": "<device name> (optional)"
  }
]`;
export const ConfigJSON = `{
  "LLD": {
    "mqtt_broker_address": "3.17.204.40",
    "mqtt_broker_port": "1883",
    "mqtt_broker_protocol": "mqtt",
    "mqtt_topic_prefix": "CS/~/CTP",
    "mqtt_config_topic": "config",
    "config_adorn_type": "HELLO",
    "agent_bin": "/usr/local/bin/csCtpAgent",
    "minimum_version": "0.0.1",
    "desired_version": "1.0.3",
    "process_sched_type": "NORMAL",
    "process_sched_priority": "20",
    "process_cgroup": "telemetry"
  }
}`;

/** Keys */
export const TablePages = {
  listDeviceModel: "list_deviceModel",
  listServiceProvider: "list_serviceProvider",
  listServiceTier: "list_serviceTier",
  listServiceOffering: "list_serviceOffering",
  listServiceInstance: "list_serviceInstance",
  listServiceEntitlement: "list_serviceEntitlement",
  listService: "list_Service",
  listGroup: "list_Group",
  listDevice: "list_Device",
  listServiceProviderConfig: "list_ServiceProviderConfig",
  listServiceConfig: "list_serviceConfig",
  listGroupConfig: "list_GroupConfig",
  listDeviceModelConfig: "list_DeviceModelConfig",
  listDeviceConfig: "list_DeviceConfig",
};

export const MessageKeys = {
  apiError: "api_error",
};

/** Service Provider related */
export const ServiceProviderActions = {
  ...BasicActions,
  group: "GroupProviders",
  service: "ListServices",
  devices: "ListDevices",
  deviceGroup: "ListDeviceGroups",
  entitlement: "ListEntitlements",
  assignDevice: "AssignDevices",
  unassignDevice: "UnassignDevices",
};
export const ServiceProviderTypes = {
  aggregator: { value: "Aggregator", label: "Aggregator" },
  tenant: { value: "Tenant", label: "Tenant" },
};

/** Service related */
export const ServiceActions = {
  ...BasicActions,
  dependency: "Dependency",
  instance: "Instance",
};
export const ServiceTypes = {
  core: { value: "core-service", label: "Core Services" },
  business: { value: "business-service", label: "Business Services" },
};
export const ServiceDeploymentEnum = {
  cloud: { value: "cloud-saas", label: "Cloud SaaS" },
  device: { value: "device-application", label: "Device Application" },
};
export const ServiceMaturityState = {
  ...BasicMaturityStates,
};

/** Service Instance related */
export const ServiceInstanceActions = {
  ...BasicActions,
};
export const ServiceInstanceMaturityState = {
  ...BasicMaturityStates,
};

/** Service Offering related */
export const ServiceOfferingActions = {
  ...BasicActions,
  viewInstance: "ViewInstance",
  editInstance: "EditInstance",
};
export const ServiceOfferingScopeRestriction = {
  labTrial: { value: "Lab-Trial", label: "Lab-Trial" },
  fieldTrial: { value: "Field-Trial", label: "Field-Trial" },
  deployment: { value: "Deployment", label: "Deployment" },
};

/** Device Model related */
export const DeviceModelActions = {
  ...BasicActions,
  listTier: "ListTier",
  listDevice: "ListDevice",
  dependency: "ModelDependency",
};
export const DeviceModelCategory = {
  primary: { value: "DEVICE-PRIMARY", label: "DEVICE-PRIMARY" },
  accessory: { value: "DEVICE-ACCESSORY", label: "DEVICE-ACCESSORY" },
};

/** Service Tier related */
export const ServiceTierActions = {
  ...BasicActions,
};

/** Device related */
export const BulkDeviceFormats = {
  csv: { value: "csv", label: "CSV" },
  json: { value: "json", label: "JSON" },
};
export const BulkDeviceCSVFormats = {
  highJump: { value: "HighJump", label: "High-Jump" },
};
export const BulkDeviceCSVError = {
  orderPresent: "Order-Already-Present",
  noPermissionToImportOrder: "User does not have Permission to Import Order",
  deviceExist: "Device-Already-Present",
  invalidFileName: "Invalid File Name",
};
export const DeviceActions = {
  view: "View",
  service: "ListServices",
  addToGroup: "AddToGroup",
  bulkAdd: "BulkAddDevices",
};

/** Service Entitlement related */
export const ServiceEntitlementActions = {
  ...BasicActions,
};
export const ServiceEntitlementProfile = {
  labTest: { value: "Lab-Testing", label: "Lab-Testing" },
  fieldTrial: { value: "Limited Field-Trial", label: "Limited Field-Trial" },
  fullDeploy: { value: "Full Deployment", label: "Full Deployment" },
};

/** Group related */
export const GroupActions = {
  ...BasicActions,
  devices: "ListDevices",
  addDevices: "AddDevices",
  addProviders: "AddProviders",
};
export const GroupLogisticStatus = {
  devProvFact: {
    value: "DeviceProviderFactory",
    label: "Device Provider Factory",
  },
  devProvWare: {
    value: "DeviceProviderWareHouse",
    label: "Device Provider WareHouse",
  },
  servProvWare: {
    value: "ServiceProviderWareHouse",
    label: "Service Provider WareHouse",
  },
  regWare: { value: "RegionalWareHouse", label: "Regional WareHouse" },
  subHome: { value: "SubscriberHome", label: "Subscriber Home" },
};
export const GroupPurpose = {
  entitlement: { value: "entitlement", label: "Entitlement" },
  management: { value: "management", label: "Management" },
  order: { value: "order", label: "Order" },
  region: { value: "region", label: "Region" },
  channel: { value: "channel", label: "Channel" },
  subChannel: { value: "sub-channel", label: "Sub-Channel" },
  codeDownload: { value: "code-download", label: "Code Download" },
};

/** Configuration Management related */
export const ConfigActions = {
  ...BasicActions,
};
export const ConfigEntity = {
  service: "Service",
  provider: "ServiceProvider",
  deviceModel: "DeviceModel",
  device: "Device",
  group: "Group",
};
